(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItDiscoveredOverTime', ["path", "securityEventsDao", "timeResolutions", "defaultChartColorList", "securityEventsLinkGenerator", function (path, securityEventsDao, timeResolutions, defaultChartColorList, securityEventsLinkGenerator) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/discovered-over-time').template('discovered-over-time'),
            scope: {
                saasList: '=',
                resolution: '=',
                eventStates: '='
            },
            link: function ($scope, element) {
                function initializeModel() {
                    if ($scope.model) {
                        return;
                    }
                    $scope.model = {
                        watchFlotOptions: false,
                        resizeAfterUpdate: true,
                        flotOptions: {
                            series: { lines: { show: true } },
                            grid: {
                                hoverable: true,
                                clickable: true,
                                borderWidth: 1,
                                tickColor: '#eee',
                                borderColor: '#eee'
                            },
                            legend: {
                                show: true,
                                position: 'nw',
                                container: element.find('.chart-legend'),
                                labelFormatter: function (label, series) {
                                    var params = {
                                        saas: _($scope.saasList).pluck('name'),
                                        resolution: $scope.resolution,
                                        current_state: $scope.eventStates,
                                        type: 'shadow_it'
                                    };
                                    if (series.shadow_it_application || series.shadow_it_app) {
                                        var shadowItApp = series.shadow_it_application || series.shadow_it_app;
                                        params.shadow_it_application = [shadowItApp];
                                    }
                                    return '<a href="' + securityEventsLinkGenerator.createHref(params) + '">' + label + '</a>';
                                }
                            },
                            yaxis: {
                                minTickSize: 1,
                                min: 0,
                                tickDecimals: 0
                            },
                            xaxis: { mode: 'time' },
                            tooltip: true,
                            tooltipOpts: {
                                defaultTheme: false,
                                content: '%y.0 users for %s application',
                                shifts: {
                                    x: 0,
                                    y: 20
                                }
                            },
                            shadowSize: 0,
                            colors: defaultChartColorList
                        }
                    };
                }
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    var resolution = timeResolutions.get($scope.resolution);
                    var result = securityEventsDao.list().params({
                        filterEnum_saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(','),
                        filterEnum_type: 'shadow_it',
                        resolutionFields: 'shadow_it_application',
                        resolutionColumn: 'create_time',
                        resolutionStep: resolution.step,
                        resolutionFromNow: true,
                        resolutionMax: resolution.stepMax
                    });
                    if ($scope.eventStates) {
                        result = result.params({ filterEnum_current_state: $scope.eventStates.join(',') });
                    }
                    return result.then(function (response) {
                        initializeModel();
                        var now = moment();
                        $scope.model.flotOptions.xaxis.minTickSize = [
                            1,
                            resolution.step
                        ];
                        $scope.model.flotOptions.xaxis.tickFormatter = function (tick) {
                            return moment(tick).format(resolution.stepFormat);
                        };
                        var apps = _(response.data.rows).chain().map(function (row) {
                            return row.shadow_it_application;
                        }).uniq().sortBy(_.identity).value();
                        var total = {};
                        $scope.model.data = _(apps).map(function (app) {
                            return {
                                label: app,
                                shadow_it_app: app,
                                data: _(_.range(resolution.stepMax)).map(function (delta) {
                                    var found = _(response.data.rows).find(function (row) {
                                        return row.shadow_it_application == app && row.delta == delta;
                                    });
                                    var count = found ? found.count : 0;
                                    total[delta] = (total[delta] || 0) + count;
                                    return [
                                        moment(now).add(-delta, resolution.step).valueOf(),
                                        count
                                    ];
                                })
                            };
                        });
                        $scope.model.data.splice(0, 0, {
                            label: 'Total',
                            data: _(_.range(resolution.stepMax)).map(function (delta) {
                                return [
                                    moment(now).add(-delta, resolution.step).valueOf(),
                                    total[delta] || 0
                                ];
                            })
                        });
                    });
                };
                $scope.$watchGroup([
                    'resolution',
                    'saasList',
                    'eventStates'
                ], function () {
                    $scope.widgetApi.reload();
                });
            }
        };
    }]);
}());